import dayjs from "dayjs"
import { isNil, isObject, } from "lodash-es"

export function setCssVar(key: string, value: string, el = document.documentElement,) {
  el.style.setProperty(key, value,)
}

export function getCssVar(key: string, el = document.documentElement,) {
  return getComputedStyle(el,).getPropertyValue(key,)
}

export function isValidStructure<T extends Recordable,>(obj: T, key: string,) {
  return key in obj
}

export function transformOptionsToMap<T extends Record<string, string | number | undefined>[],>(options?: T, config?: {
  keyField: string
  valueField: string
},) {
  if (!Array.isArray(options,) || !options.length) {
    return {}
  }

  const { keyField, valueField, } = config || {
    keyField: "label",
    valueField: "value",
  }

  return options.reduce((acc, cur,) => {
    if (cur[keyField] && isValidStructure(cur, keyField,) && isValidStructure(cur, valueField,)) {
      acc[cur[keyField]] = cur[valueField]
    }
    return acc
  }, {},)
}

type ValidArgs = (string | number | undefined)[] | [...(string | number | undefined)[], { separator: string },]
export function formatString(...args: ValidArgs) {
  const last = args.pop()
  let separator = "/"
  if (isObject(last,)) {
    separator = last.separator
  } else if (!isNil(last,)) {
    args.push(last,)
  }
  return args.filter(e => !isNil(e,),).join(separator,)
}

export function clearReactiveObject(obj: unknown,) {
  if (isObject(obj,)) {
    for (const key of Object.keys(obj,)) {
      Reflect.deleteProperty(obj, key,)
    }
  }
}

interface RuleItem {
  required?: boolean
  message: string
  trigger: "blur" | "change"
}

type RulesType = Record<string, RuleItem[]>

export function createRules(fields: Record<string, string>, trigger: "blur" | "change" = "blur",): RulesType {
  const rules: RulesType = {}
  Object.keys(fields,).forEach((key,) => {
    rules[key] = [{ required: true, message: fields[key], trigger, },]
  },)
  return rules
}

/** 获取币制 */
export function getCurrencySymbol(code: string,) {
  // 币制映射表
  const symbolMap = new Map([
    ["USD", "$",], // 美元
    ["EUR", "€",], // 欧元
    ["GBP", "£",], // 英镑
    ["CNY", "¥",], // 人民币
    ["JPY", "¥",], // 日元
    ["KRW", "₩",], // 韩元
    ["AUD", "$",], // 澳大利亚元
    ["CAD", "$",], // 加元
    ["INR", "₹",], // 印度卢比
    ["CHF", "CHF",], // 瑞士法郎
    ["DKK", "DKK",],//丹麦克朗
  ],)
  return symbolMap.get(code,)
}

export function formatLLLL(dateStr: string,) {
  return dayjs.utc(dateStr,).local().format("LLLL",)
}

/** 根据url获取店铺 */
export function getBrandByUrl(queryObj: any,) {
  return Object.keys(queryObj,).map((key,) => {
    if (key.endsWith("Cid",)) {
      // 创建一个新的对象属性，赋值为原 key
      const shopName = key?.replace(/Cid$/, "",) // shopName 是原 key
      const value = queryObj[key] // 获取 key 对应的值
      if (typeof value !== "string") {
        return {}
      }
      // 用 @ 分割字符串，得到 customerId 和 shopCode
      const [customerId, shopCode,] = value?.split("@",) || []
      return {
        shopName,
        customerId,
        shopCode,
      }
    }
    return {}
  },).filter(item => item && item.customerId,)
}
